var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('div',{attrs:{"id":"app"}},[_c('router-view')],1),_c('UpdateIndicator')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }